import wixLocation from 'wix-location';
import wixWindow from 'wix-window'; 
$w.onReady(function () { 
if (wixWindow.formFactor === "Mobile"){
let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
     $w('#hebhead').expand();
     $w('#enghead').collapse();
     //$w('#contact').hide();
     //$w('#kesher').show();
} else { 
     $w('#hebhead').collapse();
     $w('#enghead').expand();
     //$w('#contact').show();
     //$w('#kesher').hide();
}
} else {
    let myLang = wixWindow.multilingual.currentLanguage;  
if (myLang === 'he') {
$w('#hebhead').expand();
     $w('#enghead').collapse();
     $w('#contact').hide();
     $w('#kesher').show();
} else { 
     $w('#hebhead').collapse();
     $w('#enghead').expand();
     $w('#contact').show();
     $w('#kesher').hide();
}
}
});
